<template>
  <!-- 最新消息文章页面 -->
  <div class="container">
    <content-template>
      <template slot="left">滙業盃專區</template>
      <template slot="right">
        <li>
          <router-link to="enrolls">線上報名</router-link>
        </li>
        <li><a href="#" class="is-check" style="color: #5571EC;">下載表格</a></li>
        <li>
          <router-link to="huiye-rule">簡介及比賽規章</router-link>
        </li>
      </template>
      <template slot="banner">
        <img :src="otherDetail.banner" class="col-xs-12" style="padding:0px;" alt="">
      </template>
      <template slot="content">
        <div class="contents">
          <a class="download" target="_blank" :href="otherDetail.form_url">
            <img src="@/assets/image/download_small.png" alt="">{{otherDetail.form_name}}
          </a>
        </div>

      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'

export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      otherDetail: []
    }
  },
  methods: {
    getOther: function () {
      var that = this
      this.$axios.get('/huiye/other')
        .then(function (response) {
          that.otherDetail = response.data.data
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.getOther()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }

  .contents {
    margin-top: 20px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .time {
    font-size: 16px;
    color: #4A4A4A;
  }

  .title {
    font-size: 25px;
    color: #617BE4;
  }

  .download {
    font-size: 20px;
    color: #617BE4;
    text-decoration: none;
  }

  .download:hover{
    color: #526add;
  }

</style>



// WEBPACK FOOTER //
// src/components/huiye/download.vue